import axios from "axios";
import { useURL } from "../data/Config";
import { IEmployer } from "../types";

export const fetchEmployers = async (
  searchQuery?: string
): Promise<IEmployer[]> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get(`${useURL}/employers/all-employers`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      searchQuery,
    },
  });
  return response.data.employers;
};
